import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const TrendingTopics = () => {
  const navigate = useNavigate();

  const trendingTopics = [
    {
      id: 1,
      tag: "#DisasterRelief",
      posts: 1247,
      growth: "+23%",
      description: "Supporting communities affected by recent natural disasters"
    },
    {
      id: 2,
      tag: "#EducationForAll",
      posts: 892,
      growth: "+15%",
      description: "Funding educational initiatives worldwide"
    },
    {
      id: 3,
      tag: "#CleanWater",
      posts: 634,
      growth: "+31%",
      description: "Providing access to clean water in underserved areas"
    },
    {
      id: 4,
      tag: "#MentalHealth",
      posts: 567,
      growth: "+18%",
      description: "Supporting mental health awareness and resources"
    },
    {
      id: 5,
      tag: "#FoodSecurity",
      posts: 423,
      growth: "+12%",
      description: "Fighting hunger and food insecurity globally"
    }
  ];

  const handleTopicClick = (tag) => {
    navigate(`/cause-discovery?search=${encodeURIComponent(tag)}`);
  };

  const getGrowthColor = (growth) => {
    const percentage = parseInt(growth?.replace('+', '')?.replace('%', ''));
    if (percentage >= 25) return 'text-success';
    if (percentage >= 15) return 'text-accent';
    return 'text-primary';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-card-foreground">Trending Topics</h3>
        <Icon name="TrendingUp" size={18} className="text-primary" />
      </div>
      <div className="space-y-3">
        {trendingTopics?.map((topic, index) => (
          <button
            key={topic?.id}
            onClick={() => handleTopicClick(topic?.tag)}
            className="w-full text-left p-3 rounded-lg hover:bg-muted/50 transition-micro group"
          >
            <div className="flex items-start justify-between mb-1">
              <div className="flex items-center space-x-2">
                <span className="text-sm font-medium text-muted-foreground">
                  {index + 1}
                </span>
                <span className="font-medium text-primary group-hover:text-primary/80">
                  {topic?.tag}
                </span>
              </div>
              <div className="text-right">
                <p className="text-sm font-medium text-card-foreground">
                  {topic?.posts?.toLocaleString()}
                </p>
                <p className={`text-xs font-medium ${getGrowthColor(topic?.growth)}`}>
                  {topic?.growth}
                </p>
              </div>
            </div>
            <p className="text-xs text-muted-foreground line-clamp-2">
              {topic?.description}
            </p>
          </button>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <button
          onClick={() => navigate('/cause-discovery')}
          className="w-full flex items-center justify-center space-x-2 text-sm text-primary hover:text-primary/80 transition-micro"
        >
          <Icon name="Search" size={16} />
          <span>Explore All Topics</span>
        </button>
      </div>
    </div>
  );
};

export default TrendingTopics;